import { _appVersion } from 'global/cnr/contexts/useHelpers/useServiceWorker';
import _ from 'lodash';

const settingsGenericTypes = {
  settingsGeneric: 'settingsGeneric',
}

const settingsFunctionTypes = {
  allSettings: 'allSettings',
  allSettingsApp: 'allSettingsApp',
  appSettings: 'appSettings',
  backupSettings: 'backupSettings',
  fixAllSettings: 'fixAllSettings',
  formsApp: 'formsApp',
  updateAppSettings: 'updateAppSettings',
  updateAppSettingsByType: 'updateAppSettingsByType',
  updateSettingsDb: 'updateSettingsDb',
  updateViews: 'updateViews',
  transferSettings: 'transferSettings',
}

/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(settingsGenericTypes.settingsGeneric, callData)
  return data
}

export const fsfn_allSettings = (fsCall) => {
  return {
    backupSettings: (settingsDocName, update, previewInfo) => fsfn_backupSettings(fsCall, settingsDocName, update, previewInfo),
    fixAllSettings: (settingsKey, previewOnly) => fsfn_fixAllSettings(fsCall, settingsKey, previewOnly),
    // getAllSettingsApp: (vvProps_g, logging) => fsfn_getAllSettingsApp(fsCall, vvProps_g, logging),
    getAppForms: () => fsfn_getAppForms(fsCall),
    getAppSettings: (vvProps_g, logging) => fsfn_getAppSettings(fsCall, vvProps_g, logging),
    getDataItems: (dataItems) => getDataItems(fsCall, dataItems),
    updateAppSettings: (settingsDocName, appSettings, logging) => fsfn_updateAppSettings(fsCall, settingsDocName, appSettings, logging),
    updateAppSettingsByType: (settingsDocName, updateJson, updateType) => fsfn_updateAppSettingsByType(fsCall, settingsDocName, updateJson, updateType),
    updateSettingsDb: (appSettings_fns, dispatch, settings_temp, paps_state, isGlobal, sandboxOn, appUser, appSettingsChanges) => fsfn_updateSettingsDb(fsCall, appSettings_fns, dispatch, settings_temp, paps_state, isGlobal, sandboxOn, appUser, appSettingsChanges),
    // updateViews: (viewItems, views) => fsfn_updateViews(fsCall, viewItems, views),
  }
}

/**
 * Updates the settings/doc in the database. Currently this is NOT using functions. It is using updateSettingsDB
 * @param {function} dispatch 
 * @param {object} settings_temp 
 * @param {object} paps_state 
 * @param {boolean} isGlobal 
 * @param {boolean} sandboxOn 
 * @param {object} appUser 
 * @returns result
 */
const fsfn_updateSettingsDb = async (fsCall, appSettings_fns, dispatch, settings_temp, paps_state, isGlobal, sandboxOn, appUser, appSettingsChanges) => {
  try {
    const { pathViews, pathKey, rootPaths, view, viewKey, landingView, settingsDocName } = paps_state ?? {}
    const papsProps = { pathViews, pathKey, rootPaths, view, viewKey, landingView, settingsDocName }
    const callData = { settingFunctionType: settingsFunctionTypes.updateSettingsDb, settings_temp, papsProps, isGlobal, sandboxOn, appUser, appSettingsChanges }
    appSettings_fns.updateSettingsToDB(callData, dispatch)
  } catch (error) {
    console.error(error)
  }
}

/** Updates the settings
 * @param settingsDocName
 * @param appSettings global, viewItems, views
 */
const fsfn_updateAppSettings = async (fsCall, settingsDocName, appSettings, logging) => {
  const showLogs = true // logging && logging.allowLogging && logging.logUpdateAppSettings
  try {
    appSettings.appVersion = _appVersion
    const callData = { settingFunctionType: settingsFunctionTypes.updateAppSettings, settingsDocName, appSettings, showLogs }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.log('fsfn_updateAppSettings - error', error)
    showLogs && console.error(error)
    return false
  }
}

/** Updates the settings/doc in the datbase by `type`  */
const fsfn_updateAppSettingsByType = async (fsCall, settingsDocName, updateJson, updateType) => {
  try {
    const callData = { settingFunctionType: settingsFunctionTypes.allSettingsApp, settingsDocName, updateJson, updateType }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    return false
  }
}


/**
 * Gets the default setting for the app by going to firebase. settingsGeneric.allSettingsApp
 * @param {*} vvProps_g 
 * @param {*} logging 
 * @returns with {home, clients, client, event} >> {global, page} >> {vw, vi, pr, ps, other} for each of them
 */
const fsfn_getAppSettings = async (fsCall, vvProps_g, logging) => {
  const showLogs = true //logging && logging.allowLogging && logging.logAllSettingsApp 
  try {
    const callData = { settingFunctionType: settingsFunctionTypes.appSettings, vvProps: vvProps_g, showLogs }
    const { result } = await callFsFunction(fsCall, callData)
    console.log('result', result)
    return result
  } catch (error) {
    console.error(error)
  }
}

/**
 * Gets the default setting for the app by going to firebase. settingsGeneric.allSettingsApp
 * @param {*} vvProps_g 
 * @param {*} logging 
 * @returns with {home, clients, client, event} >> {global, page} >> {vw, vi, pr, ps, other} for each of them
 */
const fsfn_getAllSettingsApp = async (fsCall, vvProps_g, logging) => {
  const showLogs = logging && logging.allowLogging && logging.logAllSettingsApp
  console.log('showLogs', showLogs)
  try {
    const callData = { settingFunctionType: settingsFunctionTypes.allSettingsApp, vvProps: vvProps_g, showLogs }
    console.log('showLogs', showLogs)
    const { result } = await callFsFunction(fsCall, callData) // OK 
    return result
  } catch (error) {
    console.error(error)
  }
}


/** Retuns the settings object from firebase functions
 * @param formType
 * @param vvProps
 * @param form_handlers 
 * @returns `Forms` object firebase functions
 */
const fsfn_getAppForms = async (fsCall) => {
  try {
    console.log('fsfn_getAppForms')
    const callData = { settingFunctionType: settingsFunctionTypes.formsApp }
    const { result: appForms } = await callFsFunction(fsCall, callData) // OK
    console.log('appForms', appForms)
    return appForms
  } catch (error) {
    console.error('fsfn_getAppForms', error)
    return {}
  }
}

/**
 * fixes the settings for the selected `settingsKey`
 * @param {string} settingsKey 
 * @param {boolean} previewOnly 
 * @returns result
 */
const fsfn_fixAllSettings = async (fsCall, settingsKey, previewOnly) => {
  const callData = { settingFunctionType: settingsFunctionTypes.fixAllSettings, settingsKey, previewOnly }
  try {
    const { result } = await callFsFunction(fsCall, callData) // OK 
    return result
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} settingsDocName 
 * @param {boolean} update 
 * @param {boolean} previewInfo 
 * @returns response_data {success, result, error}
 */
const fsfn_backupSettings = async (fsCall, settingsDocName, update, previewInfo) => {
  const callData = { settingFunctionType: settingsFunctionTypes.backupSettings, settingsDocName, update, previewInfo }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    return { data: { success: false } }
  }
}


/**
 * 
 * @param {*} viewItems 
 * @param {*} views 
 * @returns  
 * @deprecated
 */
const fsfn_updateViews = async (fsCall, viewItems, views) => {
  try {
    const callData = { settingFunctionType: settingsFunctionTypes.updateViews, viewItems, views }
    const fn_response = await callFsFunction(fsCall, callData)
    return fn_response
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} fn_response 
 * @returns previewInfo
 * @deprecated
 */
export const projectDataFromResponse = (fn_response) => {
  const { data } = fn_response ? fn_response : {}
  const { result } = data ?? {}
  const { projectData, projectSettings } = result ?? {}
  const previewInfo = {
    projectData,
    projectSettings,
    previewOk: true,
  }
  return previewInfo
}

/**
 * 
 * @param {object} dataItems 
 * @returns - {headerProps, viewDataItems}
 * @deprecated
 */
const getDataItems = (dataItems) => {

  let viewDataItems = {}
  const headerProps = {}

  if (_.isArray(dataItems)) {
    dataItems.forEach(function (dataItem, index) {
      if (index === 0) {
        dataItem.forEach(function (item) {
          headerProps[item] = {}
          // headerItems.push(item)
        })
      }
    });
    // array
    dataItems.forEach(function (dataItem, index) {
      if (index > 0) {
        const di = {}
        Object.keys(headerProps).forEach(function (headerItem, headerIndex) {
          if (dataItem[headerIndex]) {
            switch (headerItem.toLowerCase()) {
              case 'id':
                break;
              default:
                // @ts-ignore
                di[_.camelCase(headerItem)] = dataItem[headerIndex]
            }
          }
        })
        viewDataItems[_.camelCase(dataItem[0])] = di
      }
    })
  } else {
    viewDataItems = dataItems
    Object.keys(dataItems).forEach(function (key, index) {
      const dataItem = dataItems[key]
      if (index === 0) {
        Object.keys(dataItem).forEach(function (keyy) {
          headerProps[keyy] = {}
        })
      }
    });
  }

  return {
    headerProps,
    viewDataItems,
  }
}